import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/context/AuthContext";
import { ShopProvider } from "@/context/ShopContext";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import Assistant from "@/pages/Assistant";
import Profile from "@/pages/Profile";
import Games from "@/pages/Games";
import Leaderboards from "@/pages/Leaderboards";
import Wallet from "@/pages/Wallet";
import Terms from "@/pages/Terms";
import PaymentReturn from "@/pages/PaymentReturn";
import CommunityDiscount from "@/pages/CommunityDiscount";
import Owner from "@/pages/Owner";
import SnakeGame from "@/pages/games/SnakeGame";
import BlockGame from "@/pages/games/BlockGame";
import RaceGame from "@/pages/games/RaceGame";
import DuckHunt from "@/pages/games/DuckHunt";
import CandyMatch from "@/pages/games/CandyMatch";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ShopProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/order/:id" element={<OrderDetail />} />
                <Route path="/assistant" element={<Assistant />} />
                <Route path="/games" element={<Games />} />
                <Route path="/games/leaderboards" element={<Leaderboards />} />
                <Route path="/wallet" element={<Wallet />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/community-discount" element={<CommunityDiscount />} />
              </Route>
              {/* Full-screen (no layout chrome) */}
              <Route path="/booking" element={<Booking />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/payment/return" element={<PaymentReturn />} />
              <Route path="/games/snake" element={<SnakeGame />} />
              <Route path="/games/block" element={<BlockGame />} />
              <Route path="/games/race" element={<RaceGame />} />
              <Route path="/games/duck" element={<DuckHunt />} />
              <Route path="/games/candy" element={<CandyMatch />} />
              <Route path="/owner" element={<Owner />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </ShopProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
